<template>
  <div class="login-box">
    <div class="ipt-group" :class="{ error: $v.form.account.$error }">
      <input type="text" v-model.trim="form.account" autocomplete="off" />
      <p class="sub-text" :class="{ 'has-text': form.account }">考试账号</p>
      <div class="line" :style="`background: ${theme.themeColor}`"></div>
      <vd-tips class="error-tip" path="form.account" />
    </div>
    <div class="ipt-group" :class="{ error: $v.form.password.$error }">
      <input
        type="password"
        v-model.trim="form.password"
        autocomplete="new-password"
      />
      <p class="sub-text" :class="{ 'has-text': form.password }">密码</p>
      <div class="line" :style="`background:${theme.themeColor}`"></div>
      <vd-tips class="error-tip" path="form.password" />
    </div>
    <el-button
      class="btn-login"
      :style="`background:${theme.buttonBackground}box-shadow:${theme.buttonShadow}`"
      :loading="loading"
      @click="onCaptcha"
    >{{ loading ? '登录中' : '登录' }}</el-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Button } from 'element-ui'
import { required, validationMixin } from '@/utils/mixin_validate'
import tips from '@/assets/json/errorTips'

/**
 * 账号+密码登录
 */
export default {
  name: 'LoginAccount',
  components: {
    ElButton: Button
  },
  mixins: [validationMixin()],
  validations() {
    // 定义检验规则时注意顺序，弹窗模式时将按顺序弹窗
    return {
      form: {
        account: {
          required
        },
        password: {
          required
        }
      }
    }
  },
  validators: {
    // 这里定义错误提示，与validations结构一一对应
    form: {
      account: {
        required: '请输入账号'
      },
      password: {
        required: '请输入密码'
      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        account: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapState(['theme', 'site_msg'])
  },
  methods: {
    async onCaptcha() {
      try {
        await this.validationTouch()
        this.loading = true
        const identity = this.form.account.trim()
        // 弹出图形验证码
        this.$verify({
          identity,
          dom_id: 'countdownBtn',
          success_callback: (ticket) => this.login(ticket),
          fail_callback: () => {
            this.loading = false
          },
          close_callback: () => {
            this.loading = false
          }
        })
      } catch (e) {
        this.form.password = ''
        this.loading = false
      }
    },
    async login(ticket) {
      try {
        const { account, password } = this.form
        const prefix = this.site_msg.accountPrefix || ''
        const username = `${prefix}${account.trim()}`
        const { user_info } = await this.$auth(
          'login_account_ticket',
          ...[username, password, 'egLIJPgY', ticket]
        )
        localStorage.setItem('currentAccount', username)
        await this.$emit('success', user_info)
        this.loading = false
      } catch (e) {
        if (tips[e] === 'Network Error') {
          this.$message.error('网络异常')
        } else {
          const tip = tips[e] || e || '未知错误，重新登录或联系管理员'
          this.$message.error(tip)
        }
        this.loading = false
        this.$emit('fail', e)
      }
    }
  }
}
</script>

<style lang="scss">
@import './index.scss';
</style>
